export interface ProviderInfo {
    augmented: boolean;
    degreeCredentials: any[];
    id: number;
    messages: any[];
    provider: Provider;
    providerCategoryCode: string;
    reviewsKey: string;
    searchRelevantLocationCount: number;
    sourceProviderKeys: string[];
    totalLocationCount: number;
}
export interface Provider {
    fullName: string;
}

export interface LocationInfo {
    name: string;
    address: Address;
    phone: string;
    distance: number;
    providerLocationKey: string;
    id: number;
    latitude: number;
    longitude: number;
    tierNumber: number;
    affiliationCount: AffiliationCount;
    rewardable: boolean;
}
export interface Address {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    country: string;
    zip: string;
    county: string;
}

export interface DataBuild {
    etlId: string;
    indexId: string;
}

export interface AffiliationCount {
    groupCount: number;
    hospitalCount: number;
}

interface OfficeHours {
    monHourFrom: number;
    monHourTo: number;
    tueHourFrom: number;
    tueHourTo: number;
    wedHourFrom: number;
    wedHourTo: number;
    thuHourFrom: number;
    thuHourTo: number;
    friHourFrom: number;
    friHourTo: number;
    satHourFrom: number;
    satHourTo: number;
    sunHourFrom: number;
    sunHourTo: number;
    isExtended: boolean;
}

interface Quality {
    recognitionGroups: unknown[];
    hasQuality: boolean;
}

type StatesOfAmerica = "Alabama" | "Alaska" | "Arizona" | "Arkansas" | "California" | "Colorado" | "Connecticut" | "Delaware" | "Florida" | "Georgia" | "Hawaii" | "Idaho" | "Illinois" | "Indiana" | "Iowa" | "Kansas" | "Kentucky" | "Louisiana" | "Maine" | "Maryland" | "Massachusetts" | "Michigan" | "Minnesota" | "Mississippi" | "Missouri" | "Montana" | "Nebraska" | "Nevada" | "New Hampshire" | "New Jersey" | "New Mexico" | "New York" | "North Carolina" | "North Dakota" | "Ohio" | "Oklahoma" | "Oregon" | "Pennsylvania" | "Rhode Island" | "South Carolina" | "South Dakota" | "Tennessee" | "Texas" | "Utah" | "Vermont" | "Virginia" | "Washington" | "West Virginia" | "Wisconsin" | "Wyoming" | "District of Columbia" | "American Samoa" | "Guam" | "Northern Mariana Islands" | "Puerto Rico" | "United States Minor Outlying Islands" | "Virgin Islands, U.S.";
interface PlansAcceptedCategory {
    "type": "category" | string;
    "name": StatesOfAmerica | string;
    "pcpEligible": boolean;
    "plans": Plan[];
    "subCategories": {
      "type": "category" | string;
      "name": StatesOfAmerica | string;
      "pcpEligible": boolean;
      "plans": Plan[];
    }[]
}

interface Plan {
    type: "plan" | string;
    name: string;
    productCode: string;
    pcpEligible: boolean;
    acceptingPatients: AcceptingPatients;
    effectiveDates: Record<string, any>; // this might not be a relevant type
    plans: unknown[];
    subCategories: unknown[];
}
interface AcceptingPatients {
    labelKey: string;
    style: "success" | string;
    messages: unknown[];
}

interface Contact {
    type: string;
    label: string;
    values: ContactValue[];
}

interface ContactValue {
    display: string;
    url: string | null;
}

export interface Attribute {
    key: string;
    name: string;
}
export interface SpecialtyAttribute extends Attribute {
    value: string[];
}
export interface OfficeHoursAttribute extends Attribute {
    value: OfficeHours;
}
export interface AreaOfFocusAttribute extends Attribute {
    value: unknown[];
}
export interface QualityAttribute extends Attribute {
    value: Quality;
}
export interface MedicalCareGroupAttribute extends Attribute {
    value: unknown[];
}
export interface QualityScoreAttribute extends Attribute {
    // Nothing added
}
export interface PlansAcceptedAttribute extends Attribute {
    value: PlansAcceptedCategory[];
}
export interface ContactAttribute extends Attribute {
    value: Contact[];
}
export interface LocationServicesAttribute extends Attribute {
    value: string[];
}
export interface ClientLocationIdAttribute extends Attribute {
    value: string;
}
export interface StaffLanguagesAttribute extends Attribute {
    value: string[];
}
export interface RemoteServicesAttribute extends Attribute {
    value: unknown[];
}
export interface CCAGroupKeyNPIAttribute extends Attribute {
    value: string[];
}
export interface CCAGroupKeyComAccsAttribute extends Attribute {
    value: string[];
}
export type AllowedAttributeTypes = (
    SpecialtyAttribute |
    OfficeHoursAttribute |
    AreaOfFocusAttribute |
    QualityAttribute |
    MedicalCareGroupAttribute |
    QualityScoreAttribute |
    PlansAcceptedAttribute |
    ContactAttribute |
    LocationServicesAttribute |
    ClientLocationIdAttribute |
    StaffLanguagesAttribute |
    RemoteServicesAttribute |
    CCAGroupKeyNPIAttribute |
    CCAGroupKeyComAccsAttribute
);
export enum ATTRIBUTE_TYPES {
    SPECIALTY = "SPECIALTY",
    OFFICE_HOURS = "OFFICE_HOURS",
    AREA_OF_FOCUS = "AREA_OF_FOCUS",
    QUALITY = "QUALITY",
    MEDICAL_CARE_GROUP = "MEDICAL_CARE_GROUP",
    QUALITY_SCORE = "QUALITY_SCORE",
    PLANS_ACCEPTED = "PLANS_ACCEPTED",
    CONTACT = "CONTACT",
    LOCATION_SERVICES = "LOCATION_SERVICES",
    CLIENT_LOCATION_ID = "CLIENT_LOCATION_ID",
    STAFF_LANGUAGES = "STAFF_LANGUAGES",
    REMOTE_SERVICES = "REMOTE_SERVICES",
    CCA_GROUP_KEY_NPI = "CCA_GROUP_KEY_NPI",
    CCA_GROUP_KEY_COMACCS = "CCA_GROUP_KEY_COMACCS",
}